import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './index.module.scss';

import PopUp from 'components/Operational/PopUp/PopUp';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Switch from 'components/Forms/Fields/Switch';
import capitalize from 'lodash/capitalize';
import AsyncDropdown from 'components/AsyncDropdown/asyncDropdown';

const SwitchOperationalAction = ({ type, item }) => {
  switch (type) {
    case 'dropdown':
      return (
        <div className={cn(styles.action, styles.operationalView)}>
          <Dropdown
            label={item.label}
            placeholder={item.placeholder}
            options={item.options}
            value={item.selectedValue}
            onChange={item.changeSelectedValue}
            isDisabled={item.isDisabled}
            name={item.label}
            optionLabelKey={item.optionLabelKey}
          />
          <Button
            text={item.btnText}
            size={item.btnSize}
            outline={item.outline}
            color={item.btnColor}
            onClick={item.btnClick}
            disabled={item.btnDisabled}
            className={styles.actionButton}
          />
        </div>
      );
    case 'button':
      return (
        <div
          className={cn(
            styles.action,
            styles.operationalViewButton,
            styles[`alignment${capitalize(item.alignment || '')}`],
          )}
        >
          <Button
            text={item.btnText}
            size={item.btnSize}
            color={item.btnColor}
            outline={item.outline}
            onClick={item.btnClickHandler}
            disabled={item.btnDisabled}
          />
        </div>
      );
    case 'toggle':
      return (
        <div className={cn(styles.action, styles.operationalView)}>
          <Switch
            label={item.label}
            checked={item.status === 'UNAVAILABLE'}
            onChange={item.onChangeHandler}
          />
        </div>
      );
    case 'asyncDropdown':
      return (
        <div className={cn(styles.action, styles.operationalView)}>
          <AsyncDropdown
            label={item.label}
            placeholder={item.placeholder}
            value={item.selectedValue}
            onChange={item.changeSelectedValue}
            isDisabled={item.isDisabled}
            name={item.label}
            optionLabelKey={item.optionLabelKey}
            dataTransform={item.dataTransform}
            fetchOptions={item.fetchOptions}
            fetchFilters={item.fetchFilters}
          />
          <Button
            text={item.btnText}
            size={item.btnSize}
            color={item.btnColor}
            outline={item.outline}
            onClick={item.btnClick}
            disabled={item.btnDisabled}
            className={styles.actionButton}
          />
        </div>
      );
    default:
      return null;
  }
};

const OperationalAction = ({ confirmPopup, ...rest }) => {
  return (
    <>
      <SwitchOperationalAction {...rest} />
      {confirmPopup && confirmPopup.showConfirmPopup && (
        <PopUp
          title={confirmPopup.popupTitle}
          statusMessage={confirmPopup.popupStatusMessage}
          actionMessage={confirmPopup.popupActionMessage}
          submit={confirmPopup.confirmBtnHandler}
          submitBtnText={confirmPopup.confirmBtnText}
          cancel={confirmPopup.cancelBtnHandler}
          cancelBtnText={confirmPopup.cancelBtnText}
          close={confirmPopup.closePopupHandler}
        />
      )}
    </>
  );
};

SwitchOperationalAction.propTypes = {
  type: PropTypes.string,
  item: PropTypes.object,
};

OperationalAction.propTypes = {
  type: PropTypes.string,
  item: PropTypes.object,
  confirmPopup: PropTypes.object,
};

export default OperationalAction;
